import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { ManagementServicesItem, ManagementServicesState } from './types';

export const actions: ActionTree<ManagementServicesState, RootState> = {
  getManagementServices: ({ commit }, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: '/acapi/mail_notify/mn-services', params: data })
        .then(resp => {
          commit('setManagementServices', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  getManagementServicesItem: ({ commit }, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: `/acapi/mail_notify/mn-services/${id}` })
        .then((resp: any) => {
          let messageTypeItem = <ManagementServicesItem>resp.data;
          messageTypeItem.id = id;
          commit('setManagementServicesItem', messageTypeItem);
          resolve(messageTypeItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  saveManagementServicesItem: ({ commit, dispatch }, data: ManagementServicesItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/mail_notify/mn-services/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getManagementServices');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  deleteManagementServicesItem: ({ commit, dispatch }, data: ManagementServicesItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/mail_notify/mn-services/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getManagementServices');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
};
